/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const updateEmployeeRequestSchema = z.object({
  password: z.coerce.string().min(0).max(500).nullable().nullish(),
  id: z.coerce.number().int().nullable().nullish(),
  lastName: z.coerce.string().min(1).max(500),
  firstName: z.coerce.string().min(1).max(500),
  email: z.coerce.string().min(0).max(500).nullable().nullish(),
  phoneNumber: z.coerce.string().nullable().nullish(),
  username: z.coerce.string().min(1).max(500),
  timesheetDaysForward: z.coerce.number().int().nullable().nullish(),
  timesheetDaysBackward: z.coerce.number().int().nullable().nullish(),
  registrationNumber: z.coerce.string().min(0).max(500).nullable().nullish(),
  enabled: z.boolean(),
  hoursPerDay: z.coerce.number().int().nullable().nullish(),
  employeeType: z.enum([
    'dipendente',
    'cliente',
    'amministratore',
    'utenteEvoluto',
    'consulente',
  ]),
  clients: z.array(
    z.object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    }),
  ),
  societa: z.array(
    z.object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    }),
  ),
  defaultSocieta: z
    .object({
      value: z.coerce.number().int(),
      label: z.coerce.string(),
    })
    .nullable()
    .nullish(),
  timesheetCanCreateProjects: z.boolean().nullable().nullish(),
  timesheetCanCreateCustomers: z.boolean().nullable().nullish(),
  timesheetCanViewUnconfirmedProjects: z.boolean().nullable().nullish(),
  timesheetCanViewUnconfirmedCustomers: z.boolean().nullable().nullish(),
  timesheetCanViewAllCustomers: z.boolean().nullable().nullish(),
});
